'use client';

import React, { createContext, useContext } from 'react';
import { DashboardPromptId } from '../app/_lib/backend/aiContext/ids';

export type DashboardPromptsContextProps = {
  /** Eligible prompt ids, already filtered and capped by the server*/
  promptIds: DashboardPromptId[];
  /** Most recently watched video's title, for the quiz/tutor chips' `{topic}` placeholder. */
  watchedVideoTopic?: string;
};

const DashboardPromptsContext = createContext<DashboardPromptsContextProps>({
  promptIds: [],
});

/**
 * Hook to access the dashboard example prompt chip ids computed server-side.
 */
export const useDashboardPrompts = (): DashboardPromptsContextProps =>
  useContext(DashboardPromptsContext);

/**
 * Delivers the server-computed dashboard prompt ids to the chip
 */
export const DashboardPromptsProvider = ({
  promptIds,
  watchedVideoTopic,
  children,
}: DashboardPromptsContextProps & { children: React.ReactNode }) => (
  <DashboardPromptsContext.Provider value={{ promptIds, watchedVideoTopic }}>
    {children}
  </DashboardPromptsContext.Provider>
);
